export function useOrganizationApi() {
  const { authStore, ...extended } = useAuthApi();
  const organizationStore = useOrganizationStore();

  const currentOrganization = computed(
    () => organizationStore.currentOrganization,
  );

  async function awaitUserAndOrganizationResolved(
    fn?: (value?: OrganizationInfo) => unknown,
  ): Promise<OrganizationInfo | undefined> {
    if (
      !authStore.isAuthed ||
      organizationStore.isOrganizationResolved ||
      organizationStore.isOrganizationRejected
    ) {
      return Promise.resolve(currentOrganization.value).then((v) => {
        fn?.(v);
        return v;
      });
    }
    await authStore.awaitUserResolved();

    return new Promise((resolve) => {
      const stop = watch(
        () => [
          organizationStore.isOrganizationResolved,
          organizationStore.isOrganizationRejected,
        ],
        ([resolved, rejected]) => {
          if (resolved || rejected) {
            stop();
            resolve(currentOrganization.value);
            fn?.(currentOrganization.value);
          }
        },
        { flush: "sync" },
      );
    });
  }

  const refreshUserAndOrganization = async () => {
    await authStore.refreshCurrentUser();
    await organizationStore.refreshCurrentOrganization();
  };

  return {
    ...extended,
    authStore,
    organizationStore,
    currentOrganization,
    awaitUserAndOrganizationResolved,
    refreshUserAndOrganization,
  };
}
